import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "../../../constants/report.css";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  tempUrl,
  tempUrlFico,
  useStateContext,
} from "../../../contexts/ContextProvider";
import { Colors } from "../../../constants/styles";
import { Loader, SearchBar } from "../../../components";
import { FetchErrorHandling } from "../../../components/FetchErrorHandling";
import {
  Box,
  Typography,
  ButtonGroup,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Snackbar,
  Alert,
} from "@mui/material";
import {
  Container,
  Card,
  Form,
  Row,
  Col,
  Table as TableReact,
} from "react-bootstrap";
import jsPDF from "jspdf";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDownloadExcel } from "react-export-table-to-excel";
import SearchIcon from "@mui/icons-material/Search";
import PrintIcon from "@mui/icons-material/Print";
import { makeStyles } from "@mui/styles";
import { useReactToPrint } from "react-to-print";
import useScreenWidth from "../../../hooks/useScreenWidth";

const useStyles = makeStyles({
  root: {
    "& .MuiTableCell-head": {
      color: "white",
      backgroundColor: Colors.blue700,
    },
  },
  tableRightBorder: {
    borderWidth: 0,
    borderRightWidth: 1,
    borderColor: "white",
    borderStyle: "solid",
  },
});

const AktivitasBukuBesar = () => {
  const screenSize = useScreenWidth();
  const tableRef = useRef(null);
  const { user, dispatch, setting } = useContext(AuthContext);
  const reportTemplateRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  let nowDate = new Date();
  let [dariTanggal, setDariTanggal] = useState(
    new Date(user.tutupperiode.dariTanggal)
  );
  let [sampaiTanggal, setSampaiTanggal] = useState(
    new Date(user.tutupperiode.sampaiTanggal)
  );
  const [dariAccount, setDariAccount] = useState("");
  const [dariAccountNama, setDariAccountNama] = useState("");
  const [sampaiAccount, setSampaiAccount] = useState("");
  const [sampaiAccountNama, setSampaiAccountNama] = useState("");

  const [COAsData, setCOAsData] = useState([]);
  const [neracaSaldosData, setNeracaSaldosData] = useState([]);
  const [aktivitasBukuBesarsBeforeData, setAktivitasBukuBesarsBeforeData] =
    useState([]);
  const [aktivitasBukuBesarsData, setAktivitasBukuBesarsData] = useState([]);
  const [searchTermDariCoa, setSearchTermDariCoa] = useState("");
  const [searchTermSampaiCoa, setSearchTermSampaiCoa] = useState("");
  const [isFetchError, setIsFetchError] = useState(false);
  const [previewPdf, setPreviewPdf] = useState(false);
  const [isCetakExcel, setIsCetakExcel] = useState(false);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openDariCoa, setOpenDariCoa] = useState(false);
  const [openSampaiCoa, setOpenSampaiCoa] = useState(false);
  const navigate = useNavigate();

  const classes = useStyles();

  const handleClickOpenDariCoa = () => {
    setOpenDariCoa(true);
  };

  const handleCloseDariCoa = () => {
    setOpenDariCoa(false);
  };

  const handleClickOpenSampaiCoa = () => {
    setOpenSampaiCoa(true);
  };

  const handleCloseSampaiCoa = () => {
    setOpenSampaiCoa(false);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const tempPostsDariCoa = COAsData.filter((val) => {
    if (searchTermDariCoa === "") {
      return val;
    } else if (
      val.kodeCOA.toUpperCase().includes(searchTermDariCoa.toUpperCase()) ||
      val.namaCOA.toUpperCase().includes(searchTermDariCoa.toUpperCase())
    ) {
      return val;
    }
  });

  const tempPostsSampaiCoa = COAsData.filter((val) => {
    if (searchTermSampaiCoa === "") {
      return val;
    } else if (
      val.kodeCOA.toUpperCase().includes(searchTermSampaiCoa.toUpperCase()) ||
      val.namaCOA.toUpperCase().includes(searchTermSampaiCoa.toUpperCase())
    ) {
      return val;
    }
  });

  useEffect(() => {
    getCOAsData();
  }, []);

  const getCOAsData = async () => {
    setLoading(true);
    try {
      const allCOAs = await axios.post(`${tempUrl}/COAsRebuild`, {
        _id: user.id,
        token: user.token,
      });
      setCOAsData(allCOAs.data);
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  const generatePDF = useReactToPrint({
    content: () => reportTemplateRef.current,
    documentTitle: "LaporanAktivitasBukuBesar",
  });

  const tampilPdf = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity()) {
      setLoading(true);
      if (sampaiTanggal < dariTanggal) {
        alert("Sampai Tanggal tidak boleh lebih kecil dari Dari Tanggal!");
        setLoading(false);
        return;
      }

      let tempSampaiTanggal = new Date(sampaiTanggal);
      let tempDariTanggalNeracaSaldo = new Date(
        tempSampaiTanggal.getFullYear(),
        tempSampaiTanggal.getMonth(),
        1
      );

      const neracaSaldos = await axios.post(
        `${tempUrlFico}/neracaSaldoPeriode`,
        {
          dariTanggal: tempDariTanggalNeracaSaldo,
          sampaiTanggal,
          _id: user.id,
          token: user.token,
          kodeCabang: user.cabang.id,
        }
      );
      // console.log("neracaSaldos.data");
      // console.log(neracaSaldos.data);
      setNeracaSaldosData(neracaSaldos.data);

      let tempSebelumSampaiTanggal = new Date(tempSampaiTanggal);
      tempSebelumSampaiTanggal.setDate(tempSebelumSampaiTanggal.getDate() - 1);

      const aktivitasBukuBesarBefore = await axios.post(
        `${tempUrlFico}/aktivitasBukuBesars`,
        {
          dariTanggal: tempDariTanggalNeracaSaldo,
          sampaiTanggal: tempSebelumSampaiTanggal,
          _id: user.id,
          token: user.token,
          kodeCabang: user.cabang.id,
        }
      );
      // console.log("aktivitasBukuBesarBefore.data");
      // console.log(aktivitasBukuBesarBefore.data);
      setAktivitasBukuBesarsBeforeData(aktivitasBukuBesarBefore.data);

      const aktivitasBukuBesar = await axios.post(
        `${tempUrlFico}/aktivitasBukuBesars`,
        {
          dariTanggal,
          sampaiTanggal,
          _id: user.id,
          token: user.token,
          kodeCabang: user.cabang.id,
        }
      );
      // console.log("aktivitasBukuBesar.data");
      // console.log(aktivitasBukuBesar.data);
      setAktivitasBukuBesarsData(aktivitasBukuBesar.data);
      setLoading(false);
      setPreviewPdf(!previewPdf);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  const textTableRight = {
    letterSpacing: "0.01px",
    textAlign: "right",
    border: "1px solid black",
  };

  const textTableRightBold = {
    letterSpacing: "0.01px",
    textAlign: "right",
    fontWeight: 700,
    border: "1px solid black",
  };

  const tableText = {
    letterSpacing: "0.01px",
  };

  const tableLastText = {
    borderTop: "1px solid black",
    letterSpacing: "0.01px",
    border: "1px solid black",
  };

  const list = [];

  let keys = Object.keys(aktivitasBukuBesarsData);
  let keysBefore = Object.keys(aktivitasBukuBesarsBeforeData);
  let tempDebet = 0;
  let totalDebet = 0;
  let tempKredit = 0;
  let totalKredit = 0;
  let tempSaldo = 0;
  let tempAkumulasiSaldo = 0;
  let totalSaldo = 0;
  let totalAkumulasiSaldo = 0;

  // If no data, keep showing the "saldo awal"
  if (Object.keys(aktivitasBukuBesarsData).length > 0) {
    for (let j = 0; j < Object.keys(aktivitasBukuBesarsData).length; j++) {
      // console.log("aktivitasBukuBesarsData[keys[j]][0].namaCOA");
      // console.log(aktivitasBukuBesarsData[keys[j]][0].namaCOA);

      if (
        parseInt(aktivitasBukuBesarsData[keys[j]][0].kodeCOA) >=
          parseInt(dariAccount) &&
        parseInt(aktivitasBukuBesarsData[keys[j]][0].kodeCOA) <=
          parseInt(sampaiAccount)
      ) {
        let findNeracaSaldo = neracaSaldosData.find(
          (neracaSaldo) =>
            neracaSaldo.kodeCOA === aktivitasBukuBesarsData[keys[j]][0].kodeCOA
        );
        let tempSaldoAwal = findNeracaSaldo.saldoAwal;

        let findAllAktivitasBukuBesarsBefore =
          aktivitasBukuBesarsBeforeData[
            aktivitasBukuBesarsData[keys[j]][0].kodeCOA
          ];

        let totalSaldoBefore = 0;
        if (findAllAktivitasBukuBesarsBefore) {
          for (let findAktivitasBukuBesarsBefore of findAllAktivitasBukuBesarsBefore) {
            if (findAktivitasBukuBesarsBefore.jenis === "D") {
              totalSaldoBefore += findAktivitasBukuBesarsBefore.jumlah;
            } else {
              totalSaldoBefore -= findAktivitasBukuBesarsBefore.jumlah;
            }
          }
        }
        // console.log("totalSaldoBefore");
        // console.log(totalSaldoBefore);
        tempSaldoAwal += totalSaldoBefore;
        tempAkumulasiSaldo += tempSaldoAwal;
        totalAkumulasiSaldo += tempSaldoAwal;
        // console.log("tempSaldoAwal");
        // console.log(tempSaldoAwal);

        list.push(
          <tr>
            <td
              style={{ fontWeight: 700, border: "1px solid black" }}
              colspan="5"
            >
              Saldo Sebelumnya:
            </td>
            <td style={textTableRight}>
              {tempSaldoAwal.toLocaleString("en-US")}
            </td>
            <td></td>
          </tr>
        );

        list.push(
          <tr>
            <td
              style={{ fontWeight: 700, border: "1px solid black" }}
              colspan="7"
            >
              Account: {aktivitasBukuBesarsData[keys[j]][0].kodeCOA} -{" "}
              {aktivitasBukuBesarsData[keys[j]][0].namaCOA}
            </td>
          </tr>
        );
        for (let i = 0; i < aktivitasBukuBesarsData[keys[j]].length; i++) {
          let tempTglJurnal = new Date(
            aktivitasBukuBesarsData[keys[j]][i].tglJurnal
          );
          if (aktivitasBukuBesarsData[keys[j]][i].jenis === "D") {
            tempDebet += aktivitasBukuBesarsData[keys[j]][i].jumlah;
            totalDebet += aktivitasBukuBesarsData[keys[j]][i].jumlah;
            tempSaldo += aktivitasBukuBesarsData[keys[j]][i].jumlah;
            tempAkumulasiSaldo += aktivitasBukuBesarsData[keys[j]][i].jumlah;
            totalSaldo += aktivitasBukuBesarsData[keys[j]][i].jumlah;
            totalAkumulasiSaldo += aktivitasBukuBesarsData[keys[j]][i].jumlah;
          } else {
            tempKredit += aktivitasBukuBesarsData[keys[j]][i].jumlah;
            totalKredit += aktivitasBukuBesarsData[keys[j]][i].jumlah;
            tempSaldo -= aktivitasBukuBesarsData[keys[j]][i].jumlah;
            tempAkumulasiSaldo -= aktivitasBukuBesarsData[keys[j]][i].jumlah;
            totalSaldo -= aktivitasBukuBesarsData[keys[j]][i].jumlah;
            totalAkumulasiSaldo -= aktivitasBukuBesarsData[keys[j]][i].jumlah;
          }
          list.push(
            <tr>
              <td style={{ border: "1px solid black" }}>{`${tempTglJurnal
                .getDate()
                .toLocaleString("en-US", {
                  minimumIntegerDigits: 2,
                  useGrouping: false,
                })}-${(tempTglJurnal.getMonth() + 1).toLocaleString("en-US", {
                minimumIntegerDigits: 2,
                useGrouping: false,
              })}-${tempTglJurnal.getFullYear()}`}</td>
              <td style={{ border: "1px solid black" }}>
                {aktivitasBukuBesarsData[keys[j]][i].noBukti}
              </td>
              <td style={{ border: "1px solid black" }}>
                {aktivitasBukuBesarsData[keys[j]][i].keterangan}
              </td>
              {aktivitasBukuBesarsData[keys[j]][i].jenis === "D" ? (
                <>
                  <td style={textTableRight}>
                    {isCetakExcel === false
                      ? aktivitasBukuBesarsData[keys[j]][
                          i
                        ].jumlah.toLocaleString("en-US")
                      : aktivitasBukuBesarsData[keys[j]][i].jumlah}
                  </td>
                  <td style={{ border: "1px solid black" }}></td>
                </>
              ) : (
                <>
                  <td style={{ border: "1px solid black" }}></td>
                  <td style={textTableRight}>
                    {isCetakExcel === false
                      ? aktivitasBukuBesarsData[keys[j]][
                          i
                        ].jumlah.toLocaleString("en-US")
                      : aktivitasBukuBesarsData[keys[j]][i].jumlah}
                  </td>
                </>
              )}
              <td style={textTableRight}>
                {isCetakExcel === false
                  ? tempSaldo.toLocaleString("en-EN")
                  : tempSaldo}
              </td>
              <td style={textTableRight}>
                {isCetakExcel === false
                  ? tempAkumulasiSaldo.toLocaleString("en-EN")
                  : tempAkumulasiSaldo}
              </td>
            </tr>
          );
        }
        list.push(
          <tr>
            <td
              style={{ fontWeight: 700, border: "1px solid black" }}
              colspan="3"
            >
              SubTotal Account: {aktivitasBukuBesarsData[keys[j]][0].kodeCOA} -{" "}
              {aktivitasBukuBesarsData[keys[j]][0].namaCOA}
            </td>
            <td style={textTableRight}>
              {isCetakExcel === false
                ? tempDebet.toLocaleString("en-EN")
                : tempDebet}
            </td>
            <td style={textTableRight}>
              {isCetakExcel === false
                ? tempKredit.toLocaleString("en-EN")
                : tempKredit}
            </td>
            <td style={textTableRight}>
              {isCetakExcel === false
                ? tempSaldo.toLocaleString("en-EN")
                : tempSaldo}
            </td>
            <td style={textTableRight}>
              {isCetakExcel === false
                ? tempAkumulasiSaldo.toLocaleString("en-EN")
                : tempAkumulasiSaldo}
            </td>
          </tr>
        );
        tempDebet = 0;
        tempKredit = 0;
        tempSaldo = 0;
        tempAkumulasiSaldo = 0;
      }
    }
  } else {
    // If there is no aktivitas buku besar before data, ex. new month with 0 transaction
    if (Object.keys(aktivitasBukuBesarsBeforeData).length === 0) {
      let tempSaldoAwal = 0;

      if (neracaSaldosData.length > 0) {
        let findNeracaSaldo = neracaSaldosData.find(
          (neracaSaldo) => neracaSaldo.kodeCOA === dariAccount
        );
        tempSaldoAwal = findNeracaSaldo.saldoAwal;
      }

      list.push(
        <tr>
          <td
            style={{ fontWeight: 700, border: "1px solid black" }}
            colspan="5"
          >
            Saldo Sebelumnya:
          </td>
          <td style={textTableRight}>
            {tempSaldoAwal.toLocaleString("en-US")}
          </td>
          <td></td>
        </tr>
      );

      list.push(
        <tr>
          <td
            style={{ fontWeight: 700, border: "1px solid black" }}
            colspan="7"
          >
            Account: {dariAccount} - {dariAccountNama}
          </td>
        </tr>
      );
    }

    for (
      let j = 0;
      j < Object.keys(aktivitasBukuBesarsBeforeData).length;
      j++
    ) {
      if (
        parseInt(aktivitasBukuBesarsBeforeData[keysBefore[j]][0].kodeCOA) >=
          parseInt(dariAccount) &&
        parseInt(aktivitasBukuBesarsBeforeData[keysBefore[j]][0].kodeCOA) <=
          parseInt(sampaiAccount)
      ) {
        // console.log("aktivitasBukuBesarsBeforeData[keysBefore[j]]");
        // console.log(aktivitasBukuBesarsBeforeData[keysBefore[j]]);

        let findNeracaSaldo = neracaSaldosData.find(
          (neracaSaldo) =>
            neracaSaldo.kodeCOA ===
            aktivitasBukuBesarsBeforeData[keysBefore[j]][0].kodeCOA
        );
        let tempSaldoAwal = findNeracaSaldo.saldoAwal;

        let findAllAktivitasBukuBesarsBefore =
          aktivitasBukuBesarsBeforeData[
            aktivitasBukuBesarsBeforeData[keysBefore[j]][0].kodeCOA
          ];

        let totalSaldoBefore = 0;
        if (findAllAktivitasBukuBesarsBefore) {
          for (let findAktivitasBukuBesarsBefore of findAllAktivitasBukuBesarsBefore) {
            if (findAktivitasBukuBesarsBefore.jenis === "D") {
              totalSaldoBefore += findAktivitasBukuBesarsBefore.jumlah;
            } else {
              totalSaldoBefore -= findAktivitasBukuBesarsBefore.jumlah;
            }
          }
        }

        tempSaldoAwal += totalSaldoBefore;
        totalSaldo += tempSaldoAwal;
        totalAkumulasiSaldo += tempSaldoAwal;

        list.push(
          <tr>
            <td
              style={{ fontWeight: 700, border: "1px solid black" }}
              colspan="5"
            >
              Saldo Sebelumnya:
            </td>
            <td style={textTableRight}>
              {tempSaldoAwal.toLocaleString("en-US")}
            </td>
            <td></td>
          </tr>
        );

        list.push(
          <tr>
            <td
              style={{ fontWeight: 700, border: "1px solid black" }}
              colspan="7"
            >
              Account: {aktivitasBukuBesarsBeforeData[keysBefore[j]][0].kodeCOA}{" "}
              - {aktivitasBukuBesarsBeforeData[keysBefore[j]][0].namaCOA}
            </td>
          </tr>
        );
      }
    }
  }

  list.push(
    <tr style={{ borderTop: "1px solid black" }}>
      <td style={{ fontWeight: 700, border: "1px solid black" }} colspan="3">
        Balance:
      </td>
      <td style={textTableRightBold}>
        {isCetakExcel === false
          ? totalDebet.toLocaleString("en-EN")
          : totalDebet}
      </td>
      <td style={textTableRightBold}>
        {isCetakExcel === false
          ? totalKredit.toLocaleString("en-EN")
          : totalKredit}
      </td>
      <td style={textTableRightBold}>
        {isCetakExcel === false
          ? totalSaldo.toLocaleString("en-EN")
          : totalSaldo}
      </td>
      <td style={textTableRightBold}>
        {isCetakExcel === false
          ? totalAkumulasiSaldo.toLocaleString("en-EN")
          : totalAkumulasiSaldo}
      </td>
    </tr>
  );

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "LaporanAktivitasBukuBesar",
    sheet: "LaporanAktivitasBukuBesar",
  });

  // NEW: kick off download after the DOM updates and ref is ready
  useEffect(() => {
    if (!isCetakExcel) return;

    // give React a tick to paint if needed
    const id = setTimeout(() => {
      console.log("tableRef.current at render:", tableRef.current);
      if (tableRef.current) {
        onDownload();
      }
      // optional: reset the flag so numbers go back to formatted view
      setIsCetakExcel(false);
    }, 0);

    return () => clearTimeout(id);
  }, [isCetakExcel, onDownload]); // depend on both

  if (loading) {
    return <Loader />;
  }

  if (isFetchError) {
    return <FetchErrorHandling />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Accounting</h3>
      <h5 style={{ fontWeight: 400 }}>Aktivitas Buku Besar</h5>
      <Typography sx={subTitleText}>
        Periode : {user.tutupperiode.namaPeriode}
      </Typography>
      <hr />

      <Card>
        <Card.Header>Rentang Tanggal</Card.Header>
        <Card.Body>
          <Form noValidate validated={validated} onSubmit={tampilPdf}>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Dari :
                  </Form.Label>
                  <Col sm="8">
                    <DatePicker
                      required
                      dateFormat="dd/MM/yyyy"
                      selected={dariTanggal}
                      // minDate={new Date(user.tutupperiode.dariTanggal)}
                      // maxDate={new Date(user.tutupperiode.sampaiTanggal)}
                      customInput={<Form.Control required />}
                      onChange={(date) => {
                        setDariTanggal(date);
                        setPreviewPdf(false);
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Sampai :
                  </Form.Label>
                  <Col sm="8">
                    <DatePicker
                      required
                      dateFormat="dd/MM/yyyy"
                      selected={sampaiTanggal}
                      // minDate={new Date(user.tutupperiode.dariTanggal)}
                      // maxDate={new Date(user.tutupperiode.sampaiTanggal)}
                      customInput={<Form.Control required />}
                      onChange={(date) => {
                        setSampaiTanggal(date);
                        setPreviewPdf(false);
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Dari Account <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      value={dariAccount}
                      placeholder="Pilih..."
                      onClick={() => handleClickOpenDariCoa()}
                      isInvalid={dariAccount.length === 0 && true}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Sampai Account <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      value={sampaiAccount}
                      placeholder="Pilih..."
                      onClick={() => handleClickOpenSampaiCoa()}
                      isInvalid={sampaiAccount.length === 0 && true}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Box sx={spacingTop}>
              <Button
                variant="contained"
                startIcon={<PrintIcon />}
                type="submit"
              >
                TAMPIL PDF
              </Button>
            </Box>
          </Form>
        </Card.Body>
      </Card>

      {previewPdf && (
        <div style={{ marginTop: "10px" }}>
          <ButtonGroup variant="outlined" color="secondary">
            <Button startIcon={<PrintIcon />} onClick={generatePDF}>
              PDF
            </Button>
            <Button
              startIcon={<SearchIcon />}
              onClick={() => {
                setIsCetakExcel(true);
                // console.log("tableRef.current at render:", tableRef.current);
                // setTimeout(() => {
                //   console.log("tableRef.current at render:", tableRef.current);

                //   if (tableRef.current) {
                //     onDownload();
                //   }
                // }, "5000");
              }}
            >
              Excel
            </Button>
          </ButtonGroup>
        </div>
      )}
      <div ref={reportTemplateRef} id="content" style={pdfContainer}>
        <div style={{ visibility: previewPdf === true ? "visible" : "hidden" }}>
          <p>
            {setting.namaPerusahaan} - {setting.alamatPerusahaan}
          </p>
          <p>({setting.kabupatenPerusahaan})</p>
          <p>{setting.kotaPerusahaan}</p>
          <p>NO. TELP. {setting.teleponPerusahaan}</p>
          <p>
            Dicetak Oleh: {user.username} | Tanggal:
            {` ${nowDate.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}-${(nowDate.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}-${nowDate.getFullYear()} `}{" "}
            | Jam:{" "}
            {` ${nowDate.getHours().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}-${(nowDate.getMinutes() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}-${nowDate.getSeconds()} `}
          </p>
          <h5 style={{ textAlign: "center", fontWeight: "700" }}>
            Laporan Aktivitas Buku Besar
          </h5>
          <p>
            Dari Tanggal :
            {` ${dariTanggal.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}-${(dariTanggal.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}-${dariTanggal.getFullYear()} `}
            S/D :
            {` ${sampaiTanggal.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}-${(sampaiTanggal.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}-${sampaiTanggal.getFullYear()}`}
          </p>
          <table class="styled-table" ref={tableRef}>
            <thead>
              <tr>
                <th style={{ border: "1px solid black" }}>Tg.</th>
                <th style={{ border: "1px solid black" }}>No. Bukti</th>
                <th style={{ border: "1px solid black" }}>Keterangan Jurnal</th>
                <th style={{ border: "1px solid black" }}>Debet</th>
                <th style={{ border: "1px solid black" }}>Kredit</th>
                <th style={{ border: "1px solid black" }}>Saldo</th>
                <th style={{ border: "1px solid black" }}>Akumulasi Saldo</th>
              </tr>
            </thead>
            <tbody>{list}</tbody>
          </table>
        </div>
      </div>

      <Dialog
        open={openDariCoa}
        onClose={handleCloseDariCoa}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Pilih Data Account`}</DialogTitle>
        <DialogActions>
          <Box sx={dialogContainer}>
            <SearchBar setSearchTerm={setSearchTermDariCoa} />
            <TableContainer component={Paper} sx={dialogWrapper}>
              <Table aria-label="simple table">
                <TableHead className={classes.root}>
                  <TableRow>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Kode
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Nama</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tempPostsDariCoa
                    .filter((val) => {
                      if (searchTermDariCoa === "") {
                        return val;
                      } else if (
                        val.kodeCOA
                          .toUpperCase()
                          .includes(searchTermDariCoa.toUpperCase()) ||
                        val.namaCOA
                          .toUpperCase()
                          .includes(searchTermDariCoa.toUpperCase())
                      ) {
                        return val;
                      }
                    })
                    .map((user, index) => (
                      <TableRow
                        key={user._id}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                          "&:hover": { bgcolor: Colors.grey300 },
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setDariAccount(user.kodeCOA);
                          setDariAccountNama(user.namaCOA);
                          handleCloseDariCoa();
                          setPreviewPdf(false);
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {user.kodeCOA}
                        </TableCell>
                        <TableCell>{user.namaCOA}</TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openSampaiCoa}
        onClose={handleCloseSampaiCoa}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Pilih Data Account`}</DialogTitle>
        <DialogActions>
          <Box sx={dialogContainer}>
            <SearchBar setSearchTerm={setSearchTermSampaiCoa} />
            <TableContainer component={Paper} sx={dialogWrapper}>
              <Table aria-label="simple table">
                <TableHead className={classes.root}>
                  <TableRow>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Kode
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Nama</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tempPostsSampaiCoa
                    .filter((val) => {
                      if (searchTermSampaiCoa === "") {
                        return val;
                      } else if (
                        val.kodeCOA
                          .toUpperCase()
                          .includes(searchTermSampaiCoa.toUpperCase()) ||
                        val.namaCOA
                          .toUpperCase()
                          .includes(searchTermSampaiCoa.toUpperCase())
                      ) {
                        return val;
                      }
                    })
                    .map((user, index) => (
                      <TableRow
                        key={user._id}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                          "&:hover": { bgcolor: Colors.grey300 },
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setSampaiAccount(user.kodeCOA);
                          setSampaiAccountNama(user.namaCOA);
                          handleCloseSampaiCoa();
                          setPreviewPdf(false);
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {user.kodeCOA}
                        </TableCell>
                        <TableCell>{user.namaCOA}</TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </DialogActions>
      </Dialog>

      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}
    </Container>
  );
};

export default AktivitasBukuBesar;

const subTitleText = {
  fontWeight: "900",
};

const spacingTop = {
  mt: 4,
};

const dialogContainer = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
};

const dialogWrapper = {
  width: "100%",
  marginTop: 2,
};

const alertBox = {
  width: "100%",
};

const tableTitle = {
  border: "1px solid black",
  padding: "10px",
};

const tableTitleRight = {
  border: "1px solid black",
  padding: "10px",
  textAlign: "right",
};

const pdfContainer = {
  padding: "20px",
  letterSpacing: "0.01px",
  fontSize: "12px",
  fontFamily: "sans-serif",
  width: "1000px",
};

const colorRed = {
  color: "red",
};
